module.exports = __webpack_public_path__ + "static/media/empty.83ff77a6.svg";